import { notify } from './notification-actions'
import Errors from '../../models/errors'
import { getText } from '../../internal/TextLabels'
import { handleErrorResponseFromBackend } from '../../sentry/handlers/backendHandler'
import { NOTIFY_DANGER, NOTIFY_WARNING } from './action-types'

export const genericError = error => {
  const errors = new Errors()

  if (error && error.status) {
    switch (parseInt(error.status, 10)) {
      case errors.codes.authFailed.code:
        return notify(NOTIFY_WARNING, getText('errors.authFailed'))
      case errors.codes.notFound.code:
        return notify(NOTIFY_DANGER, getText('errors.notFound'))
      default:
        return notify(NOTIFY_DANGER, getText('errors.general'))
    }
  }
  return notify(NOTIFY_DANGER, getText('errors.general'))
}

export const silentError = error => handleErrorResponseFromBackend(error)

export const unableToRetrievePendingApplicationError = () => {
  notify(
    NOTIFY_WARNING,
    getText('payApply.paymentMethods.pendingApplications.warning'),
  )
}

export const saveUserError = error => {
  error?.data?.validationErrors?.forEach(err => {
    if (err.fieldName === 'username') {
      if (err.message === 'Daily username change limit reached') {
        notify(NOTIFY_DANGER, getText('user.add.usernameLimit'))
      } else if (err.message === 'Invalid username.') {
        notify(NOTIFY_DANGER, getText('user.add.invalidUserName'))
      } else {
        notify(NOTIFY_DANGER, getText('user.add.userNameExists'))
      }
    }
    if (err.fieldName === 'email') {
      notify(NOTIFY_DANGER, getText('user.add.emailExists'))
    }
  })
}
